import { ConfirmOrgModalForm } from "./ConfirmOrgModalForm";

const ConfirmOrgModalFormWrapper = ({
  orgId,
  setOrgId,
  openConfirmOrgModal,
  setOpenConfirmOrgModal,
  fetchOrganizations,
}) => {
  return (
    <ConfirmOrgModalForm orgId={orgId} setOrgId={setOrgId} openConfirmOrgModal={openConfirmOrgModal} setOpenConfirmOrgModal={setOpenConfirmOrgModal} fetchOrganizations={fetchOrganizations} />
  );
};

export { ConfirmOrgModalFormWrapper };
